import React, { PureComponent } from 'react';

import { withEventState } from 'src/ver2/pages/event/context';

import LittlePerson from 'src/ver2/components/person/little';
import { NumberText } from 'src/ver2/containers/lowlavel/numberText';
import { SoloMiniSequenceRow } from 'src/ver2/containers/challenges/components/mini-sequence-row';

import Loader from 'src/ver2/components/loader';

import { Collapse, Icon } from 'antd';
import { orderBy, groupBy } from 'lodash';

// import { Link } from 'react-router-dom';

import './style.css';

// class ParticipatorsPlashka
// classname: event_participatorspage_plashka

/**
  Это просто типовая плашка, копировать отсюда
 */


class EventParticipatorsPlashka extends PureComponent {

    componentDidMount = () => {
    }

    componentDidUpdate = () => {
    }


    render() {

        // const { Event, Participators, isParticipatorsReady, upperStyle, client, ParticipatorsData, isMobile, isSoloSequencesReady } = this.props;
        // const { width, height } = upperStyle;

        const { isParticipatorsReady, Participators = [], ParticipatorsData, upperStyle: { width, height }, innerId, isMobile } = this.props;

        if (!isParticipatorsReady) return <div style={{ width, height }} className='event_participatorspage_plashka'>
            <Loader />
        </div>

        const { SettingsObj } = this.props.Event;
        let keyNames = {};
        let paramName;

        if (SettingsObj) {

            if (!(SettingsObj && SettingsObj.SpecialMain && SettingsObj.SpecialMain.ParticipatorsPage && SettingsObj.SpecialMain.ParticipatorsPage.key)) {
                return <div>NO PAGE</div>
            }

            paramName = SettingsObj.SpecialMain.ParticipatorsPage.key;

            if (SettingsObj.ParticipatorsMain && SettingsObj.ParticipatorsMain.ParticipatorsData) {
                const paramNames = SettingsObj.ParticipatorsMain.ParticipatorsData.find(x => x.name === paramName);
                if (paramNames && paramNames.options) {
                    keyNames = paramNames.options.reduce((memo, value) => {
                        return { ...memo, [value.key]: value.title }
                    }, {})
                }
            }
        } else {
            return <div>NO PAGE</div>
        }

        const getKeyName = (val) => {
            if (keyNames[val]) {
                return keyNames[val];
            }
            return `${val}`;
        }

        let Participators_ = [];
        for (let i = 0; i < Participators.length; i++) {
            const { Settings, UserId } = Participators[i];
            const SettingsObj = JSON.parse(Settings);
            const paramValue = SettingsObj[paramName];
            Participators_.push({ ...Participators[i], paramValue })
        }

        Participators_ = orderBy(Participators_, ["paramValue"], ['asc']);

        let KeyNow = 0;

        return <div style={{ width, height }} className='autoheight_plashka event_participatorspage_plashka'>

            <div className='autoheight_plashka_inner' id={innerId}>
                {Participators_.map((person) => {
                    const { paramValue } = person;

                    if (paramValue !== KeyNow) {
                        KeyNow = paramValue;
                        return <>
                            <div className='event_rounds_plashka_title'>{`${getKeyName(paramValue)}`}</div>
                            <LittlePerson
                                height={isMobile ? 40 : 70}
                                key={'plt' + person.UserId}
                                // personId={person.Id}
                                DirectPerson={{ ...person, Id: person.UserId }}
                                personsDirect
                            />
                        </>
                    }

                    return <LittlePerson
                        height={isMobile ? 40 : 70}
                        key={'plt' + person.UserId}
                        // personId={person.Id}
                        DirectPerson={{ ...person, Id: person.UserId }}
                        personsDirect
                    />
                })
                }
            </div>
        </div>
    }

}

export default withEventState(`
Event, 

Participators,
ParticipatorsData,
isParticipatorsReady,

client,
iamuser,
isMobile

`)(EventParticipatorsPlashka)